<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="840px">
        <div class="row">
            <div class="col-12 col-md-4">
                <x-date-picker v-model="form.check_in_date"
                               label="Fecha de entrada"></x-date-picker>
            </div>
            <div class="col-12 col-md-4">
                <x-time-picker v-model="form.check_in_time"
                               label="Hora de entrada"></x-time-picker>
            </div>
            <div class="col-12 col-md-4">
                <x-date-picker v-model="form.check_out_date"
                               label="Fecha de salida prevista"></x-date-picker>
            </div>
            <div class="col-12 col-md-4">
                <x-select v-model="form.room_id"
                          label="Habitación"
                          :options="rooms"
                          @input="changeRoom"></x-select>
            </div>
            <div class="col-12 col-md-4">
                <x-select v-model="form.rate_id"
                          label="Tarifa"
                          :options="rates"
                          @input="changeRate"></x-select>
            </div>
            <div class="col-12 col-md-4">
                <x-input v-model="form.price"
                         label="Precio"></x-input>
            </div>
            <div class="col-6 col-md-4">
                <x-input-number v-model="form.number_adults"
                                label="Adultos"
                                controls></x-input-number>
            </div>
            <div class="col-6 col-md-4">
                <x-input-number v-model="form.number_children"
                                label="Niños"
                                controls></x-input-number>
            </div>
            <div class="col-6 col-md-4">
                <x-input-number v-model="form.number_infants"
                                label="Bebés"
                                controls></x-input-number>
            </div>
            <div class="col-12">
                <div class="form-group" :class="{'has-danger': errors.guest_id}">
                    <label class="control-label font-weight-bold text-info">Razón social
                        <a href="#" @click.prevent="clickAddCompany">[+ Nuevo]</a>
                    </label>
                    <el-select v-model="form.company_id" filterable remote
                               class="border-left rounded-left border-info"
                               placeholder="Escriba el nombre o número de la empresa"
                               clearable
                               :remote-method="searchRemoteCompany"
                               :loading="loadingSearchCompany">
                        <el-option v-for="option in companies"
                                   :key="option.id"
                                   :value="option.id"
                                   :label="option.description"></el-option>
                    </el-select>
                    <small class="form-control-feedback" v-if="errors.company_id"
                           v-text="errors.company_id[0]"></small>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group" :class="{'has-danger': errors.guest_id}">
                    <label class="control-label font-weight-bold text-info">Huésped
                        <a href="#" @click.prevent="clickAddGuest">[+ Nuevo]</a>
                    </label>
                    <el-select v-model="form.guest_id" filterable remote
                               class="border-left rounded-left border-info"
                               placeholder="Escriba el nombre o número de documento del huésped"
                               clearable
                               :remote-method="searchRemoteGuest"
                               :loading="loadingSearchGuest">
                        <el-option v-for="option in guests"
                                   :key="option.id"
                                   :value="option.id"
                                   :label="option.description"></el-option>
                    </el-select>
                    <small class="form-control-feedback" v-if="errors.guest_id"
                           v-text="errors.guest_id[0]"></small>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group" :class="{'has-danger': errors.customer_id}">
                    <label class="control-label font-weight-bold text-info">Cliente a facturar
                        <a href="#" @click.prevent="clickAddCustomer">[+ Nuevo]</a>
                    </label>
                    <el-select v-model="form.customer_id" filterable remote
                               class="border-left rounded-left border-info"
                               placeholder="Escriba el nombre o número de documento del cliente"
                               clearable
                               :remote-method="searchRemoteCustomer"
                               :loading="loadingSearchCustomer">
                        <el-option v-for="option in customers"
                                   :key="option.id"
                                   :value="option.id"
                                   :label="option.description"></el-option>
                    </el-select>
                    <small class="form-control-feedback" v-if="errors.customer_id"
                           v-text="errors.customer_id[0]"></small>
                </div>
            </div>
            <div class="col-md-12">
                <x-input v-model="form.observations"
                         label="Observaciones"
                         type="textarea"></x-input>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose"></x-button-cancel>
                <x-button-submit @click="onSubmit" :loading="loadingSubmit"></x-button-submit>
            </div>

            <company-form :showDialog.sync="showDialogNewCompany"
                          type="customers"
                          :external="true"
                          document_type_id='6'
                          @success="successAddCompany"></company-form>

            <guest-form :showDialog.sync="showDialogNewGuest"
                        type="customers"
                        :external="true"
                        document_type_id='1'
                        @success="successAddGuest"></guest-form>

            <customer-form :showDialog.sync="showDialogNewCustomer"
                           type="customers"
                           :external="true"
                           document_type_id='6'
                           @success="successAddCustomer"></customer-form>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../components/Form/XButtonCancel"
import XButtonSubmit from "../../../../components/Form/XButtonSubmit"
import XModal from "../../../../components/XModal"
import XInput from "../../../../components/Form/XInput.vue"
import XSelect from "../../../../components/Form/XSelect.vue"
import XDatePicker from "../../../../components/Form/XDatePicker.vue"
import XInputItemSearch from "../../../../components/Form/XInputItemSearch.vue"
import XTimePicker from "../../../../components/Form/XTimePicker.vue"
import VueNumberInput from '@chenfengyuan/vue-number-input'
import XInputNumber from "../../../../components/Form/XInputNumber.vue"
import CompanyForm from "../../persons/form.vue"
import GuestForm from "../../persons/form.vue"
import CustomerForm from "../../persons/form.vue"

export default {
    name: 'ReservationForm',
    components: {
        CompanyForm, GuestForm, CustomerForm, XInputNumber,
        XTimePicker, XInputItemSearch, XDatePicker, XSelect,
        XInput, XModal, XButtonSubmit, XButtonCancel, VueNumberInput
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        recordId: {
            default: null
        }
    },
    data() {
        return {
            title: null,
            loading: false,
            loadingSubmit: false,
            loadingSearchCompany: false,
            loadingSearchGuest: false,
            loadingSearchCustomer: false,
            showDialogNewCompany: false,
            showDialogNewGuest: false,
            showDialogNewCustomer: false,
            resource: 'hotel/reservations',
            errors: {},
            form: {},
            rooms: [],
            rates: [],
            companies: [],
            guests: [],
            customers: []
        }
    },
    created() {
        this.initForm()
    },
    methods: {
        initForm() {
            this.title = '';
            this.errors = {};
            this.form = {
                id: null,
                state_type_id: '01',
                check_in_date: moment().format('YYYY-MM-DD'),
                check_in_time: moment().format('HH:mm'),
                check_out_date: moment().format('YYYY-MM-DD'),
                room_id: null,
                rate_id: null,
                price: 0,
                number_adults: 1,
                number_children: 0,
                number_infants: 0,
                company_id: null,
                guest_id: null,
                customer_id: null,
                observations: null,
            }
        },
        async initTables() {
            await this.$http.get(`/${this.resource}/tables`)
                .then(response => {
                    this.rooms = response.data.rooms
                    this.customers = response.data.customers
                });
        },
        async handleOpen() {
            console.log('handleOpen')
            this.initForm()
            await this.initTables()
            if (this.recordId) {
                await this.getRecord()
                this.title = 'Editar reservación'
                return
            }
            this.title = 'Nueva reservación'
        },
        async getRecord() {
            console.log('getRecord')
            this.loading = true
            await this.$http.get(`/${this.resource}/record/${this.recordId}`)
                .then((response) => {
                    const data = response.data
                    this.form = data.record
                    this.rooms = data.rooms
                })
            this.getRates()
            await this.reloadDataCompany(this.form.company_id)
            await this.reloadDataGuest(this.form.guest_id)
            await this.reloadDataCustomer(this.form.customer_id)
            this.loading = false
        },
        changeRoom() {
            console.log('changeRoom')
            this.rates = []
            this.form.rate_id = null
            if (this.form.room_id) {
                this.getRates()
                this.form.rate_id = (this.rates.length > 0) ? this.rates[0].id : null
                this.changeRate()
            }
        },
        getRates() {
            console.log('getRates')
            let room = this.rooms.find(row => {
                return row.id === this.form.room_id
            })
            this.rates = room.rates
        },
        changeRate() {
            console.log('changeRate')
            this.form.price = 0
            if (this.form.rate_id) {
                let rate = this.rates.find(row => {
                    return row.id === this.form.rate_id
                })
                this.form.price = (rate) ? rate.price : 0
            }
        },
        async onSubmit() {
            this.loading = true
            this.loadingSubmit = true
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.clickClose()
                        this.$emit('success')
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    this.loadingSubmit = false
                    this.loading = false
                })
        },
        async searchRemoteCompany(input) {
            console.log('searchRemoteCompany')
            if (input.length > 1) {
                this.loadingSearchCompany = true
                await this.$http.post(`/store/get_customers`, {
                    identity_document_type_id: ['6'],
                    input: input
                })
                    .then(response => {
                        this.companies = response.data.customers
                    })
                    .finally(() => {
                        this.loadingSearchCompany = false
                    })
            }
        },
        async searchRemoteGuest(input) {
            console.log('searchRemoteGuest')
            if (input.length > 1) {
                this.loadingSearchGuest = true
                await this.$http.post(`/store/get_customers`, {
                    identity_document_type_id: ['1'],
                    input: input
                })
                    .then(response => {
                        this.guests = response.data.customers
                    })
                    .finally(() => {
                        this.loadingSearchGuest = false
                    })
            }
        },
        async searchRemoteCustomer(input) {
            console.log('searchRemoteCustomer')
            if (input.length > 1) {
                this.loadingSearchCustomer = true
                await this.$http.post(`/store/get_customers`, {
                    identity_document_type_id: ['1', '6'],
                    input: input
                })
                    .then(response => {
                        this.customers = response.data.customers
                    })
                    .finally(() => {
                        this.loadingSearchCustomer = false
                    })
            }
        },
        async reloadDataCompany(id) {
            console.log('reloadDataGuest')
            await this.$http.get(`/store/get_customer_by_id/${id}`).then((response) => {
                this.companies = response.data
            })
        },
        async reloadDataGuest(id) {
            console.log('reloadDataGuest')
            await this.$http.get(`/store/get_customer_by_id/${id}`).then((response) => {
                this.guests = response.data
            })
        },
        async reloadDataCustomer(id) {
            console.log('reloadDataCustomer')
            await this.$http.get(`/store/get_customer_by_id/${id}`).then((response) => {
                this.customers = response.data
            })
        },
        clickAddCompany() {
            this.showDialogNewCompany = true
        },
        clickAddGuest() {
            this.showDialogNewGuest = true
        },
        clickAddCustomer() {
            this.showDialogNewCustomer = true
        },
        successAddCompany(data) {
            this.form.company_id = data.id
            this.companies = data.data
        },
        successAddGuest(data) {
            this.form.guest_id = data.id
            this.guests = data.data
        },
        successAddCustomer(data) {
            this.form.customer_id = data.id
            this.customers = data.data
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
